import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const [CheckboxProvider, useCheckboxContext] = buildGlobalReferenceContext("CheckboxRoot", {
  disabled: false,
  size: void 0
});

export { CheckboxProvider, useCheckboxContext };
//# sourceMappingURL=context.mjs.map
